class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.initScrollRestore();
      this.event();
    }
  }
  initScrollRestore() {
    const storageKey = 'lifefund_top_scroll_y';
    const spMedia = window.matchMedia('(max-width: 767px)');

    window.addEventListener('pagehide', () => {
      sessionStorage.setItem(storageKey, String(window.scrollY));
    });

    if (!spMedia.matches) return;

    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'reload') return;

    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return;

    const y = parseInt(saved, 10);
    if (y <= 0) return;

    const restore = () => {
      window.scrollTo(0, y);
    };

    restore();
    requestAnimationFrame(restore);
    window.addEventListener('load', restore, { once: true });

    const video = document.querySelector('.js-hero-video');
    if (video) {
      video.addEventListener('loadeddata', restore, { once: true });
    }
  }
  initHeroVideo() {
    const video = document.querySelector('.js-hero-video');
    if (!video) return;

    const isSp = window.matchMedia('(max-width: 767px)').matches;
    const src = isSp ? video.dataset.srcSp : video.dataset.srcPc;
    if (!src) return;

    video.src = src;
    video.load();
    const playPromise = video.play({ preventScroll: true });
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        video.play().catch(() => {});
      });
    }
  }
  initHeaderLogoOnMvScroll() {
    const mv = document.querySelector('.js-top-mv');
    const logoLink = document.querySelector('.js-header-logo');
    if (!mv || !logoLink) return;

    const spMedia = window.matchMedia('(max-width: 767px)');
    let ticking = false;

    const update = () => {
      if (!spMedia.matches) {
        logoLink.classList.remove('is-past-mv');
        ticking = false;
        return;
      }

      const pastMv = mv.getBoundingClientRect().bottom <= 0;
      logoLink.classList.toggle('is-past-mv', pastMv);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }
  event(){
    this.initHeroVideo();
    this.initHeaderLogoOnMvScroll();

    const movieSwiperEl = document.querySelector('.js-movie-swiper');
    const movieSlideCount = movieSwiperEl ? movieSwiperEl.querySelectorAll('.swiper-slide').length : 0;
    const shouldLoopMovieSwiper = movieSlideCount > 3;
    const movieControls = document.querySelector('.js-movie-swiper-wrapper .js-movie-swiper-controls');
    const movieDesktopMedia = window.matchMedia('(min-width: 768px)');
    const updateMovieControlsVisibility = () => {
      if (!movieControls || movieSlideCount > 3) return;
      movieControls.style.display = movieDesktopMedia.matches ? 'none' : '';
    };

    updateMovieControlsVisibility();
    if (movieDesktopMedia.addEventListener) {
      movieDesktopMedia.addEventListener('change', updateMovieControlsVisibility);
    } else if (movieDesktopMedia.addListener) {
      movieDesktopMedia.addListener(updateMovieControlsVisibility);
    }

    const movieSwiper = new Swiper('.js-movie-swiper', {
      loop: shouldLoopMovieSwiper,
      rewind: !shouldLoopMovieSwiper,
      initialSlide: 0,
      slidesPerView: 1.25,
      centeredSlides: true,
      spaceBetween: 0,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // スマホ時に表示スライド数を1.3（中央寄せ）に切り替えるブレークポイント設定
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
      pagination: {
        el: '.js-movie-swiper-wrapper .movie-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => String(number).padStart(2, '0'),
        formatFractionTotal: (number) => String(number).padStart(2, '0'),
      },
      navigation: {
        nextEl: '.js-movie-swiper-wrapper .movie-swiper-button-next',
        prevEl: '.js-movie-swiper-wrapper .movie-swiper-button-prev',
      },
    });
    movieSwiper.autoplay.stop();

    const jobSwiper = new Swiper('.js-job-swiper', {
      loop: true,
      slidesPerView: 1.6,
      spaceBetween: 8,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // スマホ時に表示スライド数を1.3（中央寄せ）に切り替えるブレークポイント設定
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 16,
        },
      },
      pagination: {
        el: '.js-job-swiper-wrapper .job-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => String(number).padStart(2, '0'),
        formatFractionTotal: (number) => String(number).padStart(2, '0'),
      },
      navigation: {
        nextEl: '.js-job-swiper-wrapper .job-swiper-button-next',
        prevEl: '.js-job-swiper-wrapper .job-swiper-button-prev',
      },
    });
    jobSwiper.autoplay.stop();

    const interviewSwiper = new Swiper('.js-interview-swiper', {
      loop: true,
      slidesPerView: 1.2,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      // スマホ時に表示スライド数を1.3（中央寄せ）に切り替えるブレークポイント設定
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.js-interview-swiper-wrapper .interview-swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => String(number).padStart(2, '0'),
        formatFractionTotal: (number) => String(number).padStart(2, '0'),
      },
      navigation: {
        nextEl: '.js-interview-swiper-wrapper .interview-swiper-button-next',
        prevEl: '.js-interview-swiper-wrapper .interview-swiper-button-prev',
      },
    });
    interviewSwiper.autoplay.stop();

    const swiperObserverMap = [
      { selector: '.js-movie-swiper-wrapper', swiper: movieSwiper },
      { selector: '.js-job-swiper-wrapper', swiper: jobSwiper },
      { selector: '.js-interview-swiper-wrapper', swiper: interviewSwiper },
    ];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const target = swiperObserverMap.find((item) => entry.target.matches(item.selector));
        if (!target) return;
        if (entry.isIntersecting) {
          target.swiper.autoplay.start();
        } else {
          target.swiper.autoplay.stop();
        }
      });
    }, { threshold: 0.1 });

    swiperObserverMap.forEach((item) => {
      const el = document.querySelector(item.selector);
      if (el) observer.observe(el);
    });

    const newsSlider = document.querySelector('.js-news-slider');
    if (newsSlider) {
      const slides = Array.from(newsSlider.querySelectorAll(':scope > a'));
      let currentIndex = 0;

      slides.forEach((slide) => {
        slide.style.transition = 'opacity 0.4s ease';
      });

      const showSlide = (index) => {
        slides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.remove('pointer-events-none', 'opacity-0');
          } else {
            slide.classList.add('pointer-events-none', 'opacity-0');
          }
        });
        currentIndex = index;
      };

      document.querySelector('.js-news-slider-next')?.addEventListener('click', () => {
        showSlide((currentIndex + 1) % slides.length);
      });

      document.querySelector('.js-news-slider-prev')?.addEventListener('click', () => {
        showSlide((currentIndex - 1 + slides.length) % slides.length);
      });
    }

    const aboutBannerZones = document.querySelectorAll('.js-top-about-banner-zone');
    const companySection = document.querySelector('.js-top-company-section');
    const featureSection = document.querySelector('.js-top-feature-section');
    const footer = document.querySelector('.js-footer');
    const aboutBanner = document.querySelector('.js-top-about-banner');
    const spMedia = window.matchMedia('(max-width: 767px)');

    if (aboutBannerZones.length > 0 && aboutBanner) {
      let ticking = false;

      const updateAboutBanner = () => {
        const viewportHeight = window.innerHeight;
        const inAboutZone = Array.from(aboutBannerZones).some((zone) => {
          const rect = zone.getBoundingClientRect();
          return rect.bottom > 0 && rect.top < viewportHeight;
        });

        const featureReached = featureSection
          ? featureSection.getBoundingClientRect().top <= viewportHeight
          : false;
        const footerReached = footer
          ? footer.getBoundingClientRect().top <= viewportHeight
          : false;

        let isVisible = false;
        let isCasual = false;

        if (spMedia.matches) {
          if (footerReached) {
            isVisible = false;
          } else if (featureReached) {
            isVisible = true;
            isCasual = true;
          } else {
            isVisible = inAboutZone;
          }
        } else {
          let companyReached = false;
          if (companySection) {
            const companyTop = companySection.getBoundingClientRect().top;
            companyReached = companyTop <= viewportHeight * 0.88;
          }
          isVisible = inAboutZone && !companyReached;
        }

        aboutBanner.classList.toggle('is-visible', isVisible);
        aboutBanner.classList.toggle('is-casual', isCasual);

        ticking = false;
      };

      const requestAboutBannerUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateAboutBanner);
      };

      updateAboutBanner();
      window.addEventListener('scroll', requestAboutBannerUpdate, { passive: true });
      window.addEventListener('resize', requestAboutBannerUpdate);
    }
  }
}
